// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__12cIq","cell":"ColumnAccessor_cell__nbnHN","firstCellAccent":"ColumnAccessor_firstCellAccent__3gCtD"};